import DIApi from './_diApi';

class AutoBusinessAPI extends DIApi {
  constructor() {
    super();
    this.controllerName = 'AutoBusinesss';
  }

  getAutoBusinessByRefType(refType) {
    const url = this.getAPIUrl() + '/AutoBusinessByRefType';
    const data = { refType };
    const request = { url, data };
    return this.getAsync(request);
  }

  getAutoBusinessDetailById(autoBusinessId) {
    const url = this.getAPIUrl() + '/AutoBusinessDetailById';
    const data = { autoBusinessId };
    const request = { url, data };
    return this.getAsync(request);
  }
}
export default new AutoBusinessAPI();
